import { gql } from '@apollo/client';

export default gql`
  mutation CreatePanelTagMutation($panelTag: PanelTagInput!) {
    createPanelTag(input: { panelTag: $panelTag }) {
      panelTag {
        id
      }
    }
  }
`;
